module.exports = __webpack_public_path__ + "img/stickers-attestation-assurance.62d10e06.jpg";